import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LoggerService } from "../../../ancestors/logger.service";
import { AppNotification } from "alloy-performance-engine-cl";
import { RelativeTimePipe } from "../../pipe/relative-time.pipe";

/**
 * Componente per la visualizzazione di una singola notifica.
 * Mostra titolo, corpo, tempo relativo e indicatore di lettura.
 */
@Component({
  selector: "ape-notification-item",
  standalone: true,
  imports: [
    CommonModule,
    RelativeTimePipe
  ],
  templateUrl: "./ape-notification-item.component.html"
})
export class ApeNotificationItemComponent {
  private logger = inject(LoggerService);

  /**
   * Dati della notifica da visualizzare
   */
  @Input({ required: true }) notification!: AppNotification;

  /**
   * Evento emesso quando la notifica viene cliccata
   */
  @Output() notificationClick = new EventEmitter<AppNotification>();

  constructor() {
    this.logger.setCaller(this.constructor.name);
  }

  /**
   * Gestisce il click sulla notifica
   */
  onItemClick(): void {
    this.logger.info(`Notification item clicked: ${this.notification.notificationId}`);
    this.notificationClick.emit(this.notification);
  }
}
